import React, { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';
import { Header } from '../components/Header';
import { useHealth } from '../hooks/useTraces';
import { SpansViewer } from '../components/otel/SpansViewer';
import { CostDashboard } from '../components/otel/CostDashboard';
import { PerformanceMetrics } from '../components/otel/PerformanceMetrics';
import { ProviderComparison } from '../components/otel/ProviderComparison';

export const SpansPage = () => {
  const [autoRefresh, setAutoRefresh] = useState(true);
  const { data: health } = useHealth();

  const handleRefresh = () => {
    // Trigger refresh for all tabs
    window.location.reload();
  };

  return (
    <div className="min-h-screen bg-background">
      <Header 
        autoRefresh={autoRefresh}
        onAutoRefreshChange={setAutoRefresh}
        onRefresh={handleRefresh}
        isHealthy={health?.status === 'healthy'}
      />

      <main className="container mx-auto p-6 space-y-6">
        <div className="space-y-2">
          <h1 className="text-3xl font-bold">OpenTelemetry Spans</h1>
          <p className="text-muted-foreground">
            Visualize and analyze LLM SDK calls from Phase 1 auto-instrumentation
          </p>
        </div>

        <Tabs defaultValue="spans" className="space-y-6">
          <TabsList>
            <TabsTrigger value="spans">Spans Viewer</TabsTrigger>
            <TabsTrigger value="cost">Cost Dashboard</TabsTrigger>
            <TabsTrigger value="performance">Performance</TabsTrigger>
            <TabsTrigger value="comparison">Provider Comparison</TabsTrigger>
          </TabsList>

          <TabsContent value="spans">
            <SpansViewer autoRefresh={autoRefresh} />
          </TabsContent>

          <TabsContent value="cost">
            <CostDashboard autoRefresh={autoRefresh} />
          </TabsContent>

          <TabsContent value="performance">
            <PerformanceMetrics autoRefresh={autoRefresh} />
          </TabsContent>

          <TabsContent value="comparison">
            <ProviderComparison autoRefresh={autoRefresh} />
          </TabsContent>
        </Tabs>
      </main>
    </div>
  );
};
